import { Component, ViewChild, Input } from '@angular/core';
import { UploadExcelOption, ExcelColumn } from '../../../upload-excel-control/upload-excel-control.model';
import { UploadExcelControlComponent } from '../../../upload-excel-control/upload-excel-control.component';
import { GridColumn } from '../../grid-control.model';

@Component({
  selector: 'sd-grid-import-excel',
  templateUrl: './grid-import-excel.component.html',
  styleUrls: ['./grid-import-excel.component.css']
})
export class GridImportExcelComponent {
  @Input() key: string;
  @Input() accept: (item: any[], successItems: any[], errorItems: any[], warningItems: []) => void | Promise<void>;
  @Input() set columns(gridColumns: GridColumn[]) {
    const columns: ExcelColumn[] = [];
    gridColumns.forEach(column => {
      if (column.ignoreImport) {
        return;
      }
      if (column.type === 'string' || column.type === 'color') {
        columns.push({
          type: 'string',
          field: column.field,
          title: column.title,
          width: column.width
        });
      } else if (column.type === 'number') {
        columns.push({
          type: 'number',
          field: column.field,
          title: column.title,
          width: column.width
        });
      } else if (column.type === 'bool') {
        columns.push({
          type: 'bool',
          field: column.field,
          title: column.title,
          width: column.width
        });
      } else if (column.type === 'date') {
        columns.push({
          type: 'date',
          field: column.field,
          title: column.title,
          width: column.width
        });
      } else if (column.type === 'datetime' || column.type === 'time') {
        columns.push({
          type: 'datetime',
          field: column.field,
          title: column.title,
          width: column.width
        });
      } else if (column.type === 'values') {
        columns.push({
          type: 'values',
          field: column.field,
          title: column.title,
          width: column.width,
          values: column.values.map(e => e.value),
        });
      } else if (column.type === 'radio') {
        columns.push({
          type: 'radio',
          field: column.field,
          title: column.title,
          width: column.width,
          values: column.values.map(e => e[column.valueField])
        });
      }
      if (column.type === 'children' && column.children?.length) {
        column.children.forEach(childColumn => {
          if (childColumn.ignoreImport) {
            return;
          }
          if (childColumn.type === 'string' || childColumn.type === 'color') {
            columns.push({
              type: 'string',
              field: childColumn.field,
              title: childColumn.title,
              width: childColumn.width
            });
          } else if (childColumn.type === 'number') {
            columns.push({
              type: 'number',
              field: childColumn.field,
              title: childColumn.title,
              width: childColumn.width
            });
          } else if (childColumn.type === 'bool') {
            columns.push({
              type: 'bool',
              field: childColumn.field,
              title: childColumn.title,
              width: childColumn.width
            });
          } else if (childColumn.type === 'date') {
            columns.push({
              type: 'date',
              field: childColumn.field,
              title: childColumn.title,
              width: childColumn.width
            });
          } else if (childColumn.type === 'datetime' || childColumn.type === 'time') {
            columns.push({
              type: 'datetime',
              field: childColumn.field,
              title: childColumn.title,
              width: childColumn.width
            });
          } else if (childColumn.type === 'values') {
            columns.push({
              type: 'values',
              field: childColumn.field,
              title: childColumn.title,
              width: childColumn.width,
              values: childColumn.values.map(e => e.value),
            });
          } else if (childColumn.type === 'radio') {
            columns.push({
              type: 'radio',
              field: childColumn.field,
              title: childColumn.title,
              width: childColumn.width,
              values: childColumn.values.map(e => e[childColumn.valueField])
            });
          }
        });
      }
    });
    this.option = {
      key: `GridImport${this.key}`,
      columns,
      onAccept: this.accept
    };
  }
  option: UploadExcelOption;
  @ViewChild('control') control: UploadExcelControlComponent;
  constructor() { }

  open = () => {
    this.control?.open();
  }
}
